export default __webpack_public_path__ + "static/media/z060mi0a.5c21e140.mp3";